import { render, staticRenderFns } from "./credit-period-detail.vue?vue&type=template&id=3bbb30bb&scoped=true"
import script from "./credit-period-detail.vue?vue&type=script&lang=js"
export * from "./credit-period-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb30bb",
  null
  
)

export default component.exports